import React, { useState } from 'react';
import { Grid, Button, Autocomplete, TextField, Box } from '@mui/material';
// import { AutoComplete } from 'antd';
import { DatePicker } from 'antd';
import type { DatePickerProps } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { fetchBusCityDesDispatch } from '../../reducers/BusReducer';
import {
	setSelectedBusArr,
	setSelectedBusDepart,
} from '../../reducers/UiReducer';
import { useNavigate } from 'react-router-dom';
// const Option = AutoComplete.Option;

const SearchEngneBus = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [departDate, setDepartDate] = useState('');
	const { buscity, busDes } = useSelector((state) => state.bus);
	const { busDepart, busArr } = useSelector((state) => state.ui);
	const [filterData, setFilterData] = useState('');
	const [filterData2, setFilterData2] = useState('');
	function disabledDate(current) {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	}

	const handleChange = (event) => {
		let results = [];
		console.log('value', event.target.value);
		let value = event.target.value;

		results =
			buscity &&
			buscity?.result &&
			buscity?.result?.cities?.filter((item) => {
				return (
					item.name.toLowerCase().includes(value.toLowerCase()) ||
					item.state.toLowerCase().includes(value.toLowerCase())
				);
			});
		console.log('value', results);
		if (results?.length <= 80) {
			setFilterData(results);
		}
	};
	console.log('first', filterData);
	const handleChange2 = (event) => {
		let value = event.target.value;
		let results = [];
		results =
			busDes &&
			busDes?.result &&
			busDes?.result?.cities?.filter((item) => {
				return (
					item.name.toLowerCase().includes(value.toLowerCase()) ||
					item.state.toLowerCase().includes(value.toLowerCase())
				);
			});
		console.log('searchresult', results);
		if (results?.length < 80) {
			setFilterData2(results);
		}
	};
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log('date', dateString);
		setDepartDate(dateString);
	};
	const handleSubmit = () => {
		let formData = {
			departure_city: busDepart.name.split(' ')[0],
			arrival_city: busArr.name.split(' ')[0],
			sourceid: busDepart.id,
			destinationid: busArr.id,
			dateofjourney: departDate,
		};
		console.log('formData', formData);
		navigate('/searchresultbus', { state: formData });
	};
	return (
		<div>
			<Grid container spacing={1} alignItems={'center'}>
				<Grid item xs={12} sm={12} md={4} lg={4}>
					<Autocomplete
						id='country-select-demo'
						sx={{ width: '100%' }}
						options={filterData && filterData?.length > 0 ? filterData : []}
						autoHighlight
						ListboxProps={{
							className: 'myCustomList',
						}}
						// value={depart}
						getOptionLabel={(option) => `${option.name}- ${option.state} `}
						renderOption={(props, option) => (
							<Box
								component='li'
								sx={{ '& > img': { mr: 2, flexShrink: 0, fontSize: 14 } }}
								{...props}>
								<p style={{ fontSize: 14, marginLeft: 5 }}>
									{option.name} - {option.state}
								</p>
							</Box>
						)}
						onChange={(event, value) => {
							dispatch(setSelectedBusDepart(value));
							let formData = {
								source: value.id,
							};
							dispatch(fetchBusCityDesDispatch(formData));
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								id='standard-basic'
								label='Leaving From'
								variant='standard'
								onChange={handleChange}
								style={{ fontSize: 12 }}
								inputProps={{
									...params.inputProps,
									autoComplete: 'new-password', // disable autocomplete and autofill
								}}
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12} sm={12} md={4} lg={4}>
					<Autocomplete
						id='country-select-demo'
						sx={{ width: '100%' }}
						options={filterData2 && filterData2?.length > 0 ? filterData2 : []}
						autoHighlight
						ListboxProps={{
							className: 'myCustomList',
						}}
						// value={depart}
						getOptionLabel={(option) => `${option.name}- ${option.state} `}
						renderOption={(props, option) => (
							<Box
								component='li'
								sx={{ '& > img': { mr: 2, flexShrink: 0, fontSize: 14 } }}
								{...props}>
								<p style={{ fontSize: 14, marginLeft: 5 }}>
									{option.name} - {option.state}
								</p>
							</Box>
						)}
						onChange={(event, value) => {
							dispatch(setSelectedBusArr(value));
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								id='standard-basic'
								label='Going To'
								variant='standard'
								onChange={handleChange2}
								style={{ fontSize: 12 }}
								inputProps={{
									...params.inputProps,
									autoComplete: 'new-password', // disable autocomplete and autofill
								}}
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12} sm={12} md={4} lg={2}>
					<DatePicker
						disabledDate={disabledDate}
						onChange={onChange}
						style={{
							width: '100%',
							padding: 8,
							border: 'none',
							borderBottom: '1px solid',
							marginTop: 9,
							borderRadius: '1px',
							boxShadow: 'none',
						}}
					/>
				</Grid>
				<Grid item xs={12} sm={12} md={4} lg={2}>
					<Button
						onClick={handleSubmit}
						variant='contained'
						style={{
							width: '100%',
							background: 'orange',
							fontWeight: 'bold',
							padding: '7px',
						}}>
						Search
					</Button>
				</Grid>
			</Grid>
		</div>
	);
};

export default SearchEngneBus;
